import type { JSONSchema4 } from 'json-schema';
import i18next from 'i18next';
import { join } from 'node:path';
import { ObjectAggregation } from '../ObjectAggregation';
import type { PageEditAggregationData } from '../ObjectAggregation';
import { DirName } from '@sap-ux/project-access';

/**
 * Represents an aggregation for macros objects.
 */
export class MacrosRootAggregation extends ObjectAggregation {
    public filePath?: string;

    /**
     * Creates an instance of `MacrosRootAggregation`.
     *
     * @param data Optional aggregation data object used to initialize properties.
     * @param schema Optional JSON schema fragment associated with this aggregation.
     */
    constructor(data?: PageEditAggregationData, schema?: JSONSchema4) {
        super(data, schema);
        this.path = ['macros'];
        this.isViewNode = true;
        this.virtual = true;
        this.allowedAnnotationCreationForms = [];
        const filePath = this.schema?.metadata?.filePath;
        if (filePath) {
            this.setFilePath(filePath);
        }
    }

    /**
     * Public method returns display name of aggregation.
     *
     * @returns Display name of building blocks node.
     */
    public getDisplayName(): string {
        return i18next.t('PAGE_EDITOR_OUTLINE_NODE_BUILDING_BLOCK');
    }

    /**
     * Method stores passed file path as source of macros node.
     *
     * @param filePath File path to set.
     */
    public setFilePath(filePath: string): void {
        this.filePath = join(DirName.Webapp, filePath);
    }
}
